export const resolveUrl = (baseUrl: string, relativePath: string): string => {
  try {
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

    const url = new URL(cleanBaseUrl);

    const basePath = url.pathname
      .split('/')
      .slice(0, -1)
      .join('/');

    const resolvedPath = new URL(
      relativePath,
      `https://example.com${basePath}/`
    ).pathname;

    return `${url.origin}${resolvedPath}`;
  } catch (error) {
    if (window.bugherdErrorLogging)
      console.error(
        `[BugHerd] Error resolving url ${relativePath} ${baseUrl}`,
        error
      );
    return relativePath;
  }
};

export const replaceRelativeUrlsWithLessRelativePaths = (
  css: string,
  cssUrl: string
) => {
  const regex = /url\((['"]?)((?!https?:|\/|data:)[^'")\s]+)(['"]?)\)/g;

  const matches = css.match(regex);
  if (!matches) return css;

  const newCss = css.replace(regex, (match, startQuote, url, endQuote) => {
    if (url.replace(/['"]/g, '').startsWith('data:')) return match;
    // Use the first quote if present, otherwise use double quotes
    const quote = startQuote || endQuote || '"';
    const resolvedUrl = resolveUrl(cssUrl, url);

    return `url(${quote}${resolvedUrl}${quote})`;
  });

  return newCss;
};
